const DOCUMENT = 'JOBS_AT_RISK_';

const actions = {
  ACTION_REQUEST: DOCUMENT + 'ACTION_REQUEST',
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_MULTI_DAY_SUCCESS: DOCUMENT + 'LOAD_MULTI_DAY_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  actionRequest: payload => ({ type: actions.ACTION_REQUEST, payload }),

  loadData: payload => ({ type: actions.LOAD, payload }),

  loadDataSuccess: payload => ({ type: actions.LOAD_SUCCESS, payload }),

  loadMultiDayDataSuccess: payload => ({ type: actions.LOAD_MULTI_DAY_SUCCESS, payload }),

  clearStore: payload => ({ type: actions.CLEAR_STORE, payload }),
};

export default actions;
